import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import Layout from './layouts/Layout';
import BrightStaffLogin from 'components/app/common/BrightStaffLogin';
import LoginService from 'components/app/common/LoginService';
import { useState } from 'react';
import CompleteRegistration from './components/app/common/CompleteRegistration';
import withErrorHandling from './components/app/common/functions/withErrorHandling';
import AuthCallbackWithMicrosoft from 'components/app/common/AuthCallbackWithMicrosoft';
import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import WODLogin from 'components/app/common/WODLogin';
const App = () => {
  const { accounts } = useMsal(); // Azure accounts
  const [showGetStartedForm, setShowGetStartedForm] = useState(false);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  const hostname = window.location.hostname;
  const params = new URLSearchParams(window.location.search);

  const domain = hostname === 'localhost' ? params.get('domain') : hostname;

  const isWod = domain === 'wod' || domain === 'wod.rebirthfitness.uk';

  const isBST = domain === 'hr' || domain === 'hr.codersden.uk';



  useEffect(() => {
    document.title = isWod ? 'WOD' : 'Bright Staff Tool';
    const checkUserAuthentication = async () => {
      try {
        if (accounts.length > 0) {
          // ✅ Azure user
          console.log('Azure user is authenticated');
          await LoginService.processAzureAccount();
          setUserAuthenticated(true);
        } else {
          // ✅ Non-Azure (email/password, Google, etc.)
          console.log('Checking non-Azure user authentication');
          const isLoggedIn = LoginService.isUserAuthenticated(); // should read token from localStorage
          if (isLoggedIn) {
            console.log('User is authenticated');
            setUserAuthenticated(true);
          } else {
            console.log('User is not authenticated');
            setUserAuthenticated(false);
          }
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkUserAuthentication();
  }, [accounts]); // run on mount + when MSAL accounts change

  if (!authChecked) {
    // optional: loading state instead of flashing login/content
    return <div>Checking session...</div>;
  }

  const handleShowRegistrationClick = () => {
    setShowGetStartedForm(!showGetStartedForm);
    window.location.href = 'https://codersden.uk/hr-software-buy-it-now/';
  };

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        {/* Azure login callback route */}
        <Route
          path="/authentication/azure/callback"
          element={<AuthCallbackWithMicrosoft />}
        />

        {/* Complete registration route */}
        <Route
          path="/authentication/complete-registration"
          exact
          element={<CompleteRegistration />}
        />

        {/* Main route for authorized users */}
        <Route
          path="/"
          element={
            userAuthenticated && !showGetStartedForm ? (
              <Layout />
            ) : isWod ? (
              <WODLogin showRegistration={handleShowRegistrationClick} />
            ) : isBST ? (
              <BrightStaffLogin
                showRegistration={handleShowRegistrationClick}
              />
            ) : (
              <BrightStaffLogin
                showRegistration={handleShowRegistrationClick}
              />
            )
          }
        />

        {/* All other routes render the same Layout component */}
        <Route path="/*" element={<Layout />} />
      </Routes>
    </Router>
  );
};

export default withErrorHandling(App);
